export function getContainerStyle() {
    return {
        root: {
            borderRadius: "4px",
            height: "100%",
            minWidth: "min-content",
            selectors: {
                "@media (forced-colors: active)": { background: "transparent" },
            },
        },
    };
}
